import { api } from '@/api';

export type SwitchOrgResponse = object;

type SwitchOrgProps = {
  orgId: string;
};

const switchOrgApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postSwitchOrg: builder.query<SwitchOrgResponse, SwitchOrgProps>({
      query: ({ orgId }: SwitchOrgProps) => ({
        url: `debug/switch-org`,
        method: 'POST',
        body: {
          new_org_id: orgId,
        },
        headers: {
          'debug-api-key': import.meta.env.VITE_DEBUG_API_KEY || '',
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyPostSwitchOrgQuery } = switchOrgApi;
